import { render } from "./UserInput.vue?vue&type=template&id=3195eafe&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=3195eafe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3195eafe"]])

export default __exports__